export default {
    coupenList: (data) => window.axios.post('coupons', data),
    couponRedeem: (data) => window.axios.post('coupons/redeem', data),
    autoApplyCoupon: (data) => window.axios.post('auto_apply_coupon_redeem', data),
}